import * as React from 'react';
import { OnboardingTooltip } from '@cian/ui-kit';

import { useChatOnboarding } from './hooks/useChatOnboarding';
import { TChatOnboardingType } from './types';
import { ChatOnboardingContent } from '../../components/ChatOnboardingContent';

interface IChatOnboardingContainerProps {
  children: React.ReactElement<unknown>;
  type: TChatOnboardingType;
}

export const ChatOnboardingContainer: React.FC<IChatOnboardingContainerProps> = ({ children, type }) => {
  const { open, closeHandler, onboardingText } = useChatOnboarding(type);

  return (
    <OnboardingTooltip
      theme="blue"
      content={<ChatOnboardingContent>{onboardingText}</ChatOnboardingContent>}
      placement="bottom-start"
      portal={false}
      open={open}
      onClose={closeHandler}
      flip={false}
    >
      <div>{children}</div>
    </OnboardingTooltip>
  );
};
